import getProducers from "utils/select_options/getProducers";

export const sort = [
  { label: "Nazwa", name: "name", style: { width: 200 } },
  { label: "E-mail", name: "email", style: { width: 240 } },
  { label: "Producent", name: "producer", style: { width: 200 } },
  { label: "Kanały", name: "channels", sortable: false },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
  {
    type: "async_select",
    name: "producer_name",
    sort_id: "producer_id",
    search_type: "in",
    getData: getProducers,
  },
];
